import React from "react";

import "./BurgerButton.css";

export default ({ onClick }) => (
  <button className="BurgerButton" onClick={onClick}>
    <span className="BurgerButton__Bar" />
    <span className="BurgerButton__Bar" />
    <span className="BurgerButton__Bar" />
  </button>
);



// WEBPACK FOOTER //
// ./src/containers/App/BurgerButton.js